/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_MarketplaceInputs */

const en_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Marketplace`)
};

const es_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercado en vivo`)
};

const fr_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace en direct`)
};

const de_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Marktplatz`)
};

const ja_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブマーケットプレイス`)
};

const zh_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时市场`)
};

const ar_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوق المباشر`)
};

const id_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace Langsung`)
};

const it_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace in Tempo Reale`)
};

const ru_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действующий маркетплейс`)
};

const pt_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace ao Vivo`)
};

const ko_live_marketplace = /** @type {(inputs: Live_MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이브 마켓플레이스`)
};

/**
* | output |
* | --- |
* | "Live Marketplace" |
*
* @param {Live_MarketplaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const live_marketplace = /** @type {((inputs?: Live_MarketplaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_MarketplaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_live_marketplace(inputs)
	if (locale === "es") return es_live_marketplace(inputs)
	if (locale === "fr") return fr_live_marketplace(inputs)
	if (locale === "de") return de_live_marketplace(inputs)
	if (locale === "ja") return ja_live_marketplace(inputs)
	if (locale === "zh") return zh_live_marketplace(inputs)
	if (locale === "ar") return ar_live_marketplace(inputs)
	if (locale === "id") return id_live_marketplace(inputs)
	if (locale === "it") return it_live_marketplace(inputs)
	if (locale === "ru") return ru_live_marketplace(inputs)
	if (locale === "pt") return pt_live_marketplace(inputs)
	return ko_live_marketplace(inputs)
});